import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { DATE_LIMIT_MONTHS } from '../../../algorithms/shoreS';
import { formatLocaleDate } from '../../../common/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1, 0),
    width: '100%',
  },
}));


const DateRangeError = ({ errors, limits, start, end }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  if (!errors?.start && !errors?.end) return null;

  const bounds = {
    min: formatLocaleDate(limits?.min),
    max: formatLocaleDate(limits?.max),
    months: DATE_LIMIT_MONTHS,
  };
  const messages = [];

  if (errors.start === 'outOfRange') {
    messages.push(
      t('forms.shoreS.acquisition.dataChooser.dateErrorStartOutOfRange', {
        value: formatLocaleDate(start),
        ...bounds,
      }),
    );
  }
  if (errors.end === 'outOfRange') {
    messages.push(
      t('forms.shoreS.acquisition.dataChooser.dateErrorEndOutOfRange', {
        value: formatLocaleDate(end),
        ...bounds,
      }),
    );
  }
  if (errors.end === 'beforeStart') {
    messages.push(t('forms.shoreS.acquisition.dataChooser.dateErrorStartAfterEnd'));
  }

  return (
    <Alert severity="error" className={classes.root}>
      <AlertTitle>{t('forms.shoreS.acquisition.dataChooser.dateErrorTitle')}</AlertTitle>
      {messages.map((message) => (
        <div key={message}>{message}</div>
      ))}
    </Alert>
  );
};

export default DateRangeError;
